import $api from "..";
import {AxiosResponse} from "axios";
import { IViewBasketResp } from "../common/api_interfaces/basket/IViewBasketResp";
import { IViewBasket } from "../common/api_interfaces/basket/IViewBasket";

export default class BasketService {
    async viewBasket(reqBody: IViewBasket): Promise<AxiosResponse<IViewBasketResp>> {
        return $api.post<IViewBasketResp>('/basket', reqBody);
    }

    async restoreBasket(ids: number[]): Promise<AxiosResponse<void>> {
        return $api.post<void>('/basket/restore', ids);
    }

 async deleteBasketFiles(reqBody: number[]): Promise<AxiosResponse<void>> {
        return $api.post<void>('/basket/deleteFile', reqBody);
    }
}